export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11905.2d7822f3.jpg";